"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicButtonMore = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const More_1 = require("../../icons/interactive/More");
const BasicButton_1 = tslib_1.__importDefault(require("../BasicButton"));
const BasicTooltip_1 = require("../../4-card/BasicTooltip");
const BasicButtonMore = ({ tooltip, ...rest }) => {
    const [t] = (0, use_t_1.useT)();
    const title = t('More');
    let element = (React.createElement(BasicButton_1.default, { ...rest },
        React.createElement(More_1.More, null)));
    if (tooltip) {
        element = React.createElement(BasicTooltip_1.BasicTooltip, { renderTooltip: () => (tooltip === true ? title : tooltip) }, element);
    }
    return element;
};
exports.BasicButtonMore = BasicButtonMore;
